export default __webpack_public_path__ + "static/media/dark_logo.bd0b0ab3.png";